module.exports = __webpack_public_path__ + "static/img/yaluanwan3.06cd5c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/yaluanwan3.png
// module id = vN3A
// module chunks = 52